import { render, staticRenderFns } from "./DiscountCodesEdit.vue?vue&type=template&id=6142edc3&scoped=true"
import script from "./DiscountCodesEdit.vue?vue&type=script&lang=js"
export * from "./DiscountCodesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6142edc3",
  null
  
)

export default component.exports